import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Container, Link, Stack, Typography } from '@mui/material';
// layouts
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import logo from '../goa_logo.png';
import LoginForm from "../components/authentication/login/LoginForm";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title="Goa Paving">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }} style={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo} alt="logo" height={200} width={200} />
          </Stack>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Goa Paving Login
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
          </Stack>
          <LoginForm />

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
